import { ScanConfigSettingType } from '@ng-cloud/badger-core/models/scan-config-setting-type';
import { ScanConfigSettingGroupType } from '@ng-cloud/badger-core/models/scan-config-setting-group-type';
import { AbstractApiModel } from '@ng-cloud/badger-core/models/abstract-api-model';

export class ScannableToScanConfig extends AbstractApiModel<ScannableToScanConfig> {
  scannableId: number;
  scannableType: string;
  scanConfigId: number

  deserialize(json: any): this {
    this.scannableId = json.scannable_id;
    this.scannableType = json.scannable_type;
    this.scanConfigId = json.scan_config_id;
    return super.deserialize(json);
  }

  serialize(): any {
    return Object.assign(super.serialize(), {
      scannable_id: this.scannableId,
      scannable_type: this.scannableType,
      scan_config_id: this.scanConfigId,
    });
  }
}
